import {
  type MailChangedEventV1,
  mailChangedEventV1Schema,
} from '@streamlain/mail-provider-contract';

export const MAIL_CHANGED_BROWSER_EVENT = 'streamlain:mail-changed';
export const MAIL_RECONNECTED_BROWSER_EVENT = 'streamlain:mail-reconnected';
const MAIL_ACCOUNTS_CHANGED_CHANNEL = 'streamlain:mail-accounts-changed';

export interface MailAccountsChangedEvent {
  workspaceId: string;
  deletedAccountId: string;
}

export function dispatchMailChangedEvent(payload: unknown): boolean {
  const parsed = mailChangedEventV1Schema.safeParse(payload);
  if (!parsed.success) return false;
  window.dispatchEvent(
    new CustomEvent<MailChangedEventV1>(MAIL_CHANGED_BROWSER_EVENT, {
      detail: parsed.data,
    })
  );
  return true;
}

export function dispatchMailReconnectEvent(): void {
  window.dispatchEvent(new Event(MAIL_RECONNECTED_BROWSER_EVENT));
}

export function broadcastMailAccountsChanged(
  event: MailAccountsChangedEvent
): boolean {
  if (
    !event.workspaceId.trim() ||
    !event.deletedAccountId.trim() ||
    typeof BroadcastChannel === 'undefined'
  ) {
    return false;
  }
  try {
    const channel = new BroadcastChannel(MAIL_ACCOUNTS_CHANGED_CHANNEL);
    channel.postMessage(event);
    channel.close();
    return true;
  } catch {
    return false;
  }
}

export function subscribeMailAccountsChanged(
  listener: (event: MailAccountsChangedEvent) => void
): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {};
  const channel = new BroadcastChannel(MAIL_ACCOUNTS_CHANGED_CHANNEL);
  const onMessage = (message: MessageEvent<unknown>) => {
    const event = message.data as Partial<MailAccountsChangedEvent> | null;
    if (
      typeof event?.workspaceId === 'string' &&
      event.workspaceId.trim() &&
      typeof event.deletedAccountId === 'string' &&
      event.deletedAccountId.trim()
    ) {
      listener({
        workspaceId: event.workspaceId,
        deletedAccountId: event.deletedAccountId,
      });
    }
  };
  channel.addEventListener('message', onMessage);
  return () => {
    channel.removeEventListener('message', onMessage);
    channel.close();
  };
}
